import './App.css';
import React from "react";
import MUIDataTable, { TableFilterList } from "mui-datatables";
import { saveAs } from 'file-saver'
import { write, utils } from 'xlsx'
import axios from "axios";
import { api } from "./api/client";
import { createTheme,ThemeProvider,adaptV4Theme } from '@mui/material/styles';
import ExpandableRowEntry from "./ExpandableRowEntry";
import * as Debounce from './plug-in/DebounceSearchRender';
import ExpandableMakineServisGecmisi from "./ExpandableMakineServisGecmisi";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Select from "react-select";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const styles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'orange' : 'gray',
        lineHeight: 1
    }),
    control: (baseStyles, state) => ({
        ...baseStyles,
        borderColor: state.isFocused ? 'grey' : 'red',

    }),

}
class MachineLocationChange extends React.Component {
    rows;
    lokasyonlarRows;
    technologyList = [];
    customerList =  [];
    productList =  [];
    locationList =  [];
    constructor(props) {
        super(props);
         this.state={childRows:[], childRowId:0,locations:[], locationChangeOpen:false,customerChangeOpen:false
            ,customerID:0,locationID:0,machineID:0,selectedLocation:null, selectedCustomer: null,selectedUYFId:null};
    }


    changeLocationConfirm = () => {
        if(this.state.selectedUYFId===null || this.state.selectedLocation===null  ||  this.state.selectedCustomer===null) {
            alert('Lütfen tüm alanları seçiniz')
        }
        else {
            this.setState({locationChangeOpen:true});

        }
    };



    locationChangeClose = () => {
        this.setState({locationChangeOpen:false,selectedLocation:null,selectedCustomer:null,selectedUYFId:null});
    };

    customerChangeClose = () => {
        this.setState({customerChangeOpen:false,customerID:0,machineID:0});
    };
    async getDatas(){

        const res = await api.get('/lookups/makineler/lokasyon-degisimi');
        const data = res.data;
        const products = data.map(d => (  this.productList.push({
            label: d.siparis_no,
            value: d.id
        })))
    }
    async getCustomerList() {
        const row = await api.get('/lookups/musteriler');
       console.log(JSON.parse(JSON.stringify(row.data)));
        this.rows=row.data;

        const customers = this.rows.map(d => (
            this.customerList.push({
                label: d.firma,
                value: d.musteri_id
            })
        ))

    }
    componentDidMount() {
        this.getDatas(true);
        this.getCustomerList()
    }

    async changeLocation(customerID,locationID, machineID) {

       await api.get('/lookups/makineler/' + machineID.value + '/musteri-lokasyon', {
            params: {
                musteri_id:customerID.value,
                lokasyon_id: locationID.value,
            }
        })
            .then((response) => {
                // Success 🎉
                console.log(response);
                this.getDatas();
                this.setState({selectedLocation:locationID})
                this.locationChangeClose()
                toast.success("Makinenin müşteri ve lokasyonu başarılı bir şekilde değiştirildi");


            })
            .catch((error) => {
                // Error 😨
                if (error.response) {

                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {

                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });

    }

    async changeCustomer(event) {
        this.setState({selectedCustomer:event})

        await api.get('/lookups/lokasyonlar', {
            params: {
                musteri_id: event.value,

            }
        })
            .then((response) => {
                // Success 🎉
                console.log(response.data)
                const location = response.data.map(d => (
                    this.locationList.push({
                        label: d.lokasyon_adi,
                        value: d.lokasyon_id
                    })
                ))

                this.setState({
                    locations:this.locationList
                })

            })
            .catch((error) => {
                // Error 😨
                if (error.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });

    }



    render() {
   const {selectedUYFId,locations} = this.state

        return (
            <React.Fragment>
                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover

                />
                <Dialog
                    open={this.state.locationChangeOpen}
                    onClose={this.locationChangeClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Lokasyonu değiştirme onayı"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Bu makinenin müşteri ve lokasyonunu değiştirmek istediğinizden emin misiniz?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.locationChangeClose}>İptal</Button>
                        <Button onClick={()=>{this.changeLocation(this.state.selectedCustomer,this.state.selectedLocation, this.state.selectedUYFId).then((r) => console.log(r))}}>
                          Müşteri ve  Lokasyonu Değiştir
                        </Button>
                    </DialogActions>
                </Dialog>

    <div style={{width:'50%'}}>
        <br/>
        <br/>
        <h3>Makine Müşteri ve Lokasyon Güncelleme Formu</h3>

        <label>Makine UYF</label>
        <Select options={this.productList}    value={this.state.selectedUYFId}       styles={styles}
                onChange={event => this.setState({selectedUYFId:event})}
        />
        <label>Müşteri</label>
        <Select options={this.customerList}    value={this.state.selectedCustomer}       styles={styles}
                onChange={(event)=>{
                    this.changeCustomer(event)
                }}
        />
        <label>Lokasyon</label>
        <Select options={ locations }  value={this.state.selectedLocation}   styles={styles}
                onChange={event => this.setState({selectedLocation:event})}
        />
        <Button variant="contained" size={"medium"} color="success" style={{alignItems:'flex-end'}} onClick={()=>{
            this.changeLocationConfirm()
        }}>Müşteri ve Lokasyon Güncelle</Button>
    </div>

           </React.Fragment>
        );
    }
}

export default MachineLocationChange;
